var Req = window.Req;
Req.localPath = Req.localPath || "/skin/v1/";
Req(
    "mobilefix", // <-- fixes rotation zoom bug in Mobile Safari, and scrolls page down to hide url bar...

    "eutils",
    "ga",

    "labelizor",
    "q-paginazor",
    "onformatchange",
    "mobilemenu",
    "query",
    "selectybox",
    "q-alistdatesplit",
    "listscroller",
    "x/hammer",
    "delayedhighlight",
    "imgpop 2",
    "treecollapse",
    "autovalidate",
    "anchortags",
    "filtertable",
    "mailtoenabler",
    "q-quickfeedback",
    "makepagestyles",

    function () {
        "use strict";

        var $ = window.jQuery;

        var $html = $("html");

        var $win = $(window);
        var $body = $("body");
        var $doc = $(document);

        const cfg = require("./config.json");
        const formatMonitor = $.formatChange(
            FormatChange.makeGroups(cfg.mediaFormats)
        );
        var media = formatMonitor.media;

        const isNormalStyles = !/(?:^|;\s*)userstyles=on(?:$|\s*;)/.test(
            document.cookie
        );

        var txt;
        var i18n = { en: {} };

        i18n.is = $.beget(i18n.en);
        txt = i18n[$("html").attr("lang")] || i18n.en;

        // =========================================================================================================================
        //   Default Configs
        // =========================================================================================================================

        // =========================================================================================================================
        //   Actions
        // =========================================================================================================================

        var loggedIn = window.EPLICA_loggedin;
        var noop = $.noop;

        var tagFileAndExternalLinks = function (root) {
            i18n.en.newWindow = "Opens in new window";
            i18n.is.newWindow = "Opnast í nýjum vafraglugga";
            i18n.en.fileText = "file";
            i18n.is.fileText = "skjal";

            root.query("a:not(.videolink)").anchorTags({
                usePatterns: ["doc", "pdf", "xls"],
                // localDomains: ['\\.*.eplica.is','\\.*.domain.is'],
                onTag: function (link, is) {
                    var text = is.pattern
                        ? is.pattern[0].toUpperCase() + " " + txt.fileText
                        : is.external
                        ? txt.newWindow
                        : "";
                    text &&
                        link
                            .attr("target", "_blank")
                            .attr(
                                "title",
                                $.trim(link.attr("title") || link.text()) +
                                    " (" +
                                    text +
                                    ")"
                            );

                    if (link.find("img").length) {
                        link.addClass("has-image");
                    }

                    var gaCat = is.external
                        ? "external"
                        : is.tel
                        ? "telephone"
                        : is.mailto
                        ? "email"
                        : is.pattern
                        ? "download"
                        : "";
                    if (window.ga && gaCat) {
                        link.on("click", function (/*e*/) {
                            window.gaHXM.eventPing(
                                gaCat,
                                is.pattern ? "click-" + is.pattern[0] : "click",
                                link
                                    .attr("href")
                                    .replace(/^(tel|mailto):/i, ""),
                                1,
                                is.external ? true : false
                            );
                        });
                    }
                },
            });
        };

        var prepArticleContent = function (root) {
            root.query(".article").each(function () {
                var article = $(this);
                // _linkedImagesCarousel( article );
                // _showImages( article );
                _collapseCollapseBlocks(article);
                _openArticleImagesInModal(article);

                if (article.find(".focusbox").length > 0) {
                    _focusbox(article);
                }

                if (article.find("ul.dwnpg a, a.dwnpg").length > 0) {
                    _downPageLinks(article);
                }

                if (article.is(".event")) {
                    _initEvent(article);
                }

                if (article.is(".news, .event, .share")) {
                    _injectShareBtns(article);
                }

                if (article.find(".gmaps-btn").length > 0) {
                    _initMaps(article);
                }

                if (article.find(".godwn").length > 0) {
                    article.find(".godwn").on("click", function (e) {
                        e.preventDefault();
                        $("body,html").animate(
                            { scrollTop: $($(this).attr("href")).height() },
                            800
                        );
                    });
                }

                // show tooltips/definitions registered as title-attributes of specific links (.tooltip)
                if (article.find("a.tooltip").length > 0) {
                    article.find("a.tooltip").each(function () {
                        var tooltipElm = $(this);
                        tooltipElm.addClass('found');
                        var tipText = tooltipElm.attr("title");
                            if (tipText.length > 0) {
                                var tipElm = $('<span></span>').addClass('tiptext').text(tipText).appendTo(tooltipElm);
                                tooltipElm.attr("title","");
                            }
                        // rely on hover for non-small media sizes
                        if (media.isSmall) {
                            tooltipElm.on('click', function (e) {
                                e.preventDefault();
                                article.find('.tiptext.active').not(tipElm).removeClass('active'); // hide other open elements
                                tipElm.toggleClass('active');
                            })
                        }
                    });
                }
            });

            root.query(".article").each(function () {
                var article = $(this);
                _enhanceVideolinks(article);
                _enhanceAudiolinks(article);
            });
        };

        // var _showImages = function(article) {

        //     article.find('.imagebox ins.image').css({ 'background-image': 'url(' + article.find('.imagebox ins.image').attr('data-src') + ')' });
        // };

        var _openArticleImagesInModal = function (article) {
            article
                .find("img")
                .not(".nopop, .imagebox img")
                .wrap('<a class="img mini" href="#"></a>');
            article.find("img.nopop").wrap('<span class="img"></span>');

            article
                .find("a.mini")
                .filter("a.mini")
                .each(function () {
                    var imgsrc = $(this)
                        .find("img")
                        .attr("src")
                        .replace(/\/[^/]+\/([^/]+)$/, "/xlarge/$1");
                    $(this).attr("href", imgsrc);
                })
                .end()
                .imgPopper();
        };

        var _injectShareBtns = function (article) {
            Req("sharebtns", function () {
                var list = $("<ul />");
                list.sharebtns({
                    wrap: "li",
                    custom: true,
                    // countNone: true,
                    twitter: 2,
                    // gplus:     2,
                    // pinterest: 3,
                    fbshare: 1,
                    facebook: false,
                }).end();

                $(list)
                    .wrapAll('<div class="share-widgets" />')
                    .prepend("<li><span>Deila</span></li>")
                    .parent()
                    .appendTo($(".pgwrap .pginner"));
                // .appendTo( article.find('.boxbody') );
            });
        };

        var _downPageLinks = function (article) {
            article.find("ul.dwnpg a, a.dwnpg").on("click", function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                var offsettop = 20;
                if (media.isLarge) {
                    offsettop = 120;
                }
                var top = $(href).offset().top - offsettop;

                if ($(href).is(".collapse-closed")) {
                    $(href).click();
                }

                $("html, body").animate(
                    {
                        scrollTop: top,
                    },
                    1000
                );
            });
        };

        var _collapseCollapseBlocks = function (article) {
            article.find(".collapse").each(function () {
                var head = $(this).addClass("collapse-active collapse-closed");
                head.nextUntil("h2, h3, hr, .buttons, .share-widgets")
                    .wrapAll(
                        '<div class="collapseouter" style="display: none" />'
                    )
                    .wrapAll('<div class="collapsebox" />');

                var converttext = $(this)
                    .text()
                    .replace("á", "a")
                    .replace("é", "e")
                    .replace("ó", "o")
                    .replace("ú", "u")
                    .replace("í", "i")
                    .replace("æ", "ae")
                    .replace("ö", "o")
                    .replace("þ", "th")
                    .replace(" ", "-")
                    .toLowerCase()
                    .replace(/[^A-Z0-9]/gi, "");
                $(this).attr("data-title", converttext);

                head.wrapInner('<a href="#" />').on("click", function (e) {
                    e.preventDefault();

                    head.toggleClass("collapse-closed")
                        .next()
                        .slideToggle("fast");

                    if ($(this).is(".collapse-closed")) {
                        $.setFrag("");
                    } else {
                        $.setFrag($(this).data("title"));
                    }
                });
            });

            console.log("GetFrag: ", $.getFrag());
            var url = document.location.href;
            var idx = url.indexOf("#");
            var hash = idx != -1 ? url.substring(idx + 1) : "";
            if (hash.length > 0) {
                var currentCollapse = article.find(
                    ".collapse[data-title=" + hash + "]"
                );
                if (currentCollapse.length > 0) {
                    setTimeout(
                        function () {
                            currentCollapse.click();
                            console.log(
                                "scroll",
                                $(currentCollapse).offset().top
                            );
                            var offsettop = 20;
                            if (media.isLarge) {
                                offsettop = 120;
                            }
                            var top =
                                $(currentCollapse).offset().top - offsettop;

                            $("html, body").animate(
                                {
                                    scrollTop: top,
                                },
                                1000
                            );
                        },
                        500,
                        top
                    );
                }
            }
        };

        var _enhanceVideolinks = function (article) {
            article.find("a.videolink").Req("q-videolinks", function () {
                $(this).videoLinks();
            });
        };

        var _enhanceAudiolinks = !("src" in $("<audio/>")[0])
            ? noop
            : function (article) {
                  article.find("a.audioplayer").each(function (i, link) {
                      $("<audio/>")
                          .prop({
                              src: link.href,
                              preload: "none",
                              controls: true,
                          })
                          .insertBefore(link)
                          .append(link);
                  });
              };

        var _initEvent = function (article) {
            article.alistDateSplit({
                shortMonths: false,
                dateSel: ".meta .date",
            });

            if (article.find(".meta > li").length > 1) {
                article.find(".meta").addClass("many");
            }
        };

        var _initMaps = function (article) {
            // Change google maps link into map
            var articleBox = article,
                mapLink = articleBox.find(".gmaps-btn").attr("href");
            if (/google/.test(mapLink)) {
                articleBox.find(".gmaps-btn").remove();
                articleBox.append(
                    '<div class="gmaps"><div class="boxbody"><iframe src="' +
                        mapLink +
                        '" width="100%" height="388" frameborder="0" style="border:0" allowfullscreen></iframe></div></div><hr class="stream" />'
                );
            }
        };

        // .mnav treecollapse
        var collapseMobileMenu = function () {
            $doc.one("mobilemenuopened", function (/*e*/) {
                $(".mnav")
                    .treeCollapse({
                        branch: "li:has(ul)",
                        doTogglers: 1,
                        toggler: "> a.expand",
                        startOpen: "li.parent:has(ul), li.current:has(ul)",
                    })
                    .on("BranchOpen", function (e, data) {
                        $(data.branch)
                            .closest("ul")
                            .find("> li.open, > li.open .open")
                            .not(data.branch)
                            .find("> a.expand")
                            .trigger("click");
                    });
            });
        };

        var _focusbox = function (article) {
            article.find(".focusbox").each(function () {
                var head = $(this)
                    .addClass("focusbox-title")
                    .removeClass("focusbox");
                head.nextUntil("hr, .buttons, .share-widgets")
                    .addBack()
                    .wrapAll('<div class="focusbox" />');
            });
        };

        var initArticlelists = $html.is(".home")
            ? noop
            : function () {
                  var articlelist = $(".articlelist");

                  // if ( articlelist.is('.lazy') || articlelist.find('.paging').length ) {
                  if (!articlelist.is(".nopaging")) {
                      articlelist.paginazor({
                          loadLazyImages: true,
                          infinityLoad: "notfirst",
                          showPagesLeft: true,
                          maintainStatusOnBack: true,
                      }) /*
                .on('listupdated', function (e, data) {
                    // do stuff to loaded items
                    // $(data.itemlist).alistDateSplit();
                })
                .trigger('listupdated', articlelist.find('.item'))*/;
                  }

                  if (articlelist.is(".events")) {
                      _initEvents($(".articlelist.events"));
                  }

              };

        var removeRedundantSpinners = function () {
            // hide spinner background after all images are loaded to catch non-lazy loaded
            // adapted from https://www.seancdavis.com/posts/wait-until-all-images-loaded/
            $('.articlelist').each(function () {
                var articlelist = $(this);
                articlelist.addClass('seen');
                var articleListImages = $(this).find('img');
                var imagesLoaded = 0;
                var totalImages = articleListImages.length;
                // Step through each image in the DOM, clone it, attach an onload event
                // listener, then set its source to the source of the original image. When
                // that new image has loaded, fire the imageLoaded() callback.
                articleListImages.each(function (idx, img) {
                    $('<img>').on('load', imageLoaded).attr('src', $(img).attr('src'));
                });

                function imageLoaded() {
                    imagesLoaded++;
                    if (imagesLoaded == totalImages) {
                        articlelist.addClass('allimagesloaded');
                    }
                }

                }
            )

        }

        var _initEvents = function (articlelist) {
            articlelist.alistDateSplit({ shortMonths: false });

            if (!$html.is(".home")) {
                articlelist
                    .paginazor({
                        loadLazyImages: true,
                        infinityLoad: "notfirst",
                        showPagesLeft: true,
                        maintainStatusOnBack: true,
                    })
                    .on("listupdated", function (e, data) {
                        $(data.itemlist).alistDateSplit({
                            shortMonths: false,
                            dateSel: ".meta .date",
                        });
                    })
                    .trigger("listupdated", articlelist.find(".item"));
            }
        };

        var initForms = function (root) {
            root.find(
                "#qstr, #dstr, #sagain, .fi_txt input, .fi_bdy textarea"
            ).labelizor(); // labelize .qsearch input
            _enforceButtonElms(root);

            root.find("select").selectybox();

            root.query("form").autoValidate({
                errorMsgType: "inlineonly",
                validateEachField: "change",
            });
        };

        // turn old-school input buttons into proper <button> elements
        var _enforceButtonElms = function (root) {
            root.find("input:submit, input:reset").each(function () {
                var inp = $(this);
                $("<button>")
                    .attr({
                        type: inp.attr("type"),
                        name: inp.attr("name"),
                    })
                    .text(inp.val())
                    .replaceAll(inp);
            });
        };

        var handleTelephoneLinks = function () {
            // depends on formatChange()
            i18n.is.callPrompt = "Hringja í ";
            i18n.en.callPrompt = "Call ";
            $doc.on("click", 'a[href^="tel:"]', function (e) {
                if (media.isLarge) {
                    var m = $(this)
                            .text()
                            .match(/\+?\d[\s\-\d]+\d/),
                        num = (m && m[0]) || this.href.substr(4);
                    if (!confirm(txt.callPrompt + num + " ?")) {
                        e.preventDefault();
                    }
                }
            });
        };

        // Forsíða
        var initHomepage = !$html.is(".home")
            ? noop
            : function () {
                  // Banner
                  var $imagebanner = $(".imgbanner.slideshow");
                  $imagebanner
                      .on("whenonscreen", function () /*e*/ {
                          $imagebanner.addClass("onscreen");
                      })
                      .whenOnScreen({
                          live: true,
                          ranges: {
                              visible: { top: "-10%s", bottom: "-20%s" },
                          },
                      });

                  var $image = $(".imgbanner .image");
                  if ($image.length) {
                      if ($html.is(".home")) {
                          $win.on("formatchange.imagebanner", function (/*e*/) {
                              if (
                                  media.format === "phone" ||
                                  media.format === "phablet"
                              ) {
                                  $image.each(function () {
                                      $(this).css({
                                          "background-image":
                                              "url(" +
                                              $(this).attr("data-imgsmall") +
                                              ")",
                                      });
                                  });
                              } else if (
                                  media.format === "tablet" ||
                                  media.format === "netbook"
                              ) {
                                  $image.each(function () {
                                      $(this).css({
                                          "background-image":
                                              "url(" +
                                              $(this).attr("data-imgmedium") +
                                              ")",
                                      });
                                  });
                              } else {
                                  $image.each(function () {
                                      $(this).css({
                                          "background-image":
                                              "url(" +
                                              $(this).attr("data-imglarge") +
                                              ")",
                                      });
                                  });
                              }
                          }).trigger("formatchange.imagebanner");
                      } else {
                          $win.on("formatchange.imagebanner", function (/*e*/) {
                              if (media.format === "phone") {
                                  $image.each(function () {
                                      $(this).css({
                                          "background-image":
                                              "url(" +
                                              $(this).attr("data-imgsmall") +
                                              ")",
                                      });
                                  });
                              } else if (
                                  media.format === "phablet" ||
                                  media.format === "tablet" ||
                                  media.format === "netbook"
                              ) {
                                  $image.each(function () {
                                      $(this).css({
                                          "background-image":
                                              "url(" +
                                              $(this).attr("data-imgmedium") +
                                              ")",
                                      });
                                  });
                              } else {
                                  $image.each(function () {
                                      $(this).css({
                                          "background-image":
                                              "url(" +
                                              $(this).attr("data-imglarge") +
                                              ")",
                                      });
                                  });
                              }
                          }).trigger("formatchange.imagebanner");
                      }

                      var procoCarousel = $(".imgbanner");
                      if (procoCarousel.length) {
                          procoCarousel
                              .hammer()
                              .filter(function () {
                                  return $(this).find(".item").length > 1;
                              })
                              .listscroller({
                                  item: ".item",
                                  paging: true,
                                  statusPager: false,
                                  jumpPager: true,
                                  animation: "crossfade",
                                  speed: 600,
                                  autoScrollDelay: 8000,
                                  windowSize: 1,
                                  stepSize: 1,
                              });
                      }
                  }

                  var quicklist = $(".articlelist.quicklist");
                  quicklist
                      .find(".item")
                      .on("whenonscreen", function () /*e*/ {
                          quicklist.addClass("onscreen");
                          $(this)
                              .find(".image")
                              .css({
                                  "background-image":
                                      "url(" +
                                      $(this).find(".image").data("src") +
                                      ")",
                              });
                          $(this).find(".img").addClass("lazy-loaded");
                      })
                      .whenOnScreen({
                          live: true,
                          ranges: {
                              visible: { top: "-10%s", bottom: "-20%s" },
                          },
                      });

                  // Laus störf (large article)
                  $(
                      ".articlelist.large h3, .articlelist.large .summary"
                  ).wrapAll('<div class="text" />');

                  $(".articlelist.quickbox")
                      .find(".item")
                      .on("whenonscreen", function () /*e*/ {
                          $(this).addClass("ready");
                      })
                      .whenOnScreen({
                          live: true,
                          ranges: {
                              visible: { top: "-10%s", bottom: "-20%s" },
                          },
                      });

                  // Hide source when it is named the same as the box
                  $(".articlelist.quickbox .item").each(function () {
                      var itmSrc = $(this).find(".source");
                      if (
                          itmSrc.find("a").attr("href") === "/vekjum-athygli-a"
                      ) {
                          itmSrc.hide();
                      }
                  });

                  var homenews = $(".homenews");
                  homenews
                      .find(".item")
                      .on("whenonscreen", function () /*e*/ {
                          homenews.addClass("onscreen");

                          if (media.isLarge && $(this).is(".firstitem")) {
                              var homenewsImgsrc = $(this)
                                  .find(".image")
                                  .data("src")
                                  .replace(
                                      /\/[^/]+\/([^/]+)$/,
                                      "/home-article/$1"
                                  );
                              $(this)
                                  .find(".image")
                                  .css({
                                      "background-image":
                                          "url(" + homenewsImgsrc + ")",
                                  });
                          } else {
                              $(this)
                                  .find(".image")
                                  .css({
                                      "background-image":
                                          "url(" +
                                          $(this).find(".image").data("src") +
                                          ")",
                                  });
                          }
                          $(this).find(".img").addClass("lazy-loaded");
                      })
                      .whenOnScreen({
                          live: true,
                          ranges: {
                              visible: { top: "-10%s", bottom: "-20%s" },
                          },
                      });

                  var largebox = $(".articlelist.large");
                  largebox
                      .find(".item")
                      .on("whenonscreen", function () /*e*/ {
                          $(this)
                              .find(".image")
                              .css({
                                  "background-image":
                                      "url(" +
                                      $(this).find(".image").data("src") +
                                      ")",
                              });
                          $(this).find(".img").addClass("lazy-loaded");
                      })
                      .whenOnScreen({
                          live: true,
                          ranges: {
                              visible: { top: "-10%s", bottom: "-20%s" },
                          },
                      });

                  var homeevents = $(".articlelist.events");
                  homeevents.alistDateSplit({ shortMonths: false });
                  homeevents
                      .find(".item")
                      .on("whenonscreen", function () /*e*/ {
                          homeevents.addClass("onscreen");
                      })
                      .whenOnScreen({
                          live: true,
                          ranges: {
                              visible: { top: "-10%s", bottom: "-20%s" },
                          },
                      });

                  // Opnunartími
                  _openhours();
              };

        var _openhours = function () {
            var openhours = $(".openhourslist");
            openhours.find(".boxhead").wrapInner('<a href="#"></a>');
            openhours.find(".boxhead > a").on("click", function (e) {
                e.preventDefault();
                $html.toggleClass("openhours-open");
            });

            $doc.on("keyup", function (e) {
                if (e.which === 27 && $html.is(".openhours-open")) {
                    $html.removeClass("openhours-open");
                }
            });

            $body.click(function (e) {
                var $target = $(e.target);
                if (
                    !$target.parents().is(".openhourslist") &&
                    !$target.is(".openhourslist")
                ) {
                    $html.removeClass("openhours-open");
                }
            });
        };

        /** Alert box on homepage */
        var initAlertBox = function () {
            const alert = $(".pgtop .alert");
            if (alert.find(".item").length > 0) {
                alert.hide();
                $html.addClass("alertbox alerts-" + alert.find(".item").length);
                $(".pgtop").before(alert);
                alert.fadeIn();
            }
        };

        /**************************************************************************************/
        /*** Megamenu  ************************************************************************/
        var initMegaMenu = function () {
            var mnav = $(".mnav");

            mnav.find(".level2 > li.branch > a").on("click", function (e) {
                e.preventDefault();
            });

            $win.on("formatchange.megaMenu", function (e) {
                if (media.becameLarge) {
                    mnav.find(".level1 > li.branch > a").on(
                        "click",
                        function (e) {
                            e.preventDefault();
                        }
                    );

                    mnav.find(".level2").each(function () {
                        $(this).wrap(
                            '<div class="megamenu"><div class="boxbody"></div></div>'
                        );
                    });

                    mnav.delayedHighlight({
                        delegate: ".level1 > .branch",
                        delay: 700,
                        delayOut: 200,
                        sticky: true,
                        click: true,
                        clickToggles: false,
                        clickCancels: false,
                    })
                        .on("highlighton", function (e) {
                            $("html").addClass("curtain");

                            // --- 'Mannlíf' menu, get next event ---
                            if (
                                e.target.classList.contains("green") &&
                                $(e.target).find(
                                    ".megamenu .articlelist.events"
                                ).length < 1
                            ) {
                                $html.addClass("ajax-wait");
                                $.get("/mannlif", "justPicPos=pgmenu")
                                    .done(function (data) {
                                        if (
                                            $(e.target).find(
                                                ".megamenu .articlelist.events"
                                            ).length < 1
                                        ) {
                                            data = $.getResultBody(
                                                $.imgSuppress(data)
                                            ).find(
                                                ".articlelist.events.nopaging"
                                            );
                                            data.addClass("loading");
                                            data.find(".item:first").addClass(
                                                "current"
                                            );
                                            data.find(".item")
                                                .last()
                                                .addClass("last");
                                            data.alistDateSplit({
                                                shortMonths: false,
                                            });

                                            // var nextlink = $('<a href="#" class="next">Næsti viðburður</a>').on('click', function() {
                                            //     data.find('.item.current').removeClass('current').next('.item').addClass('current');

                                            //     if( data.find('.item.current').is('.last')) {
                                            //         nextlink.hide();
                                            //     }
                                            // });
                                            // data.find('.boxbody').append(nextlink);
                                            data.find(".boxbody").append(
                                                '<span class="next">Næsti viðburður</span>'
                                            );

                                            $(e.target)
                                                .find(".megamenu .boxbody")
                                                .append(data);
                                        }
                                    })
                                    .always(function () {
                                        var target = $(e.target);
                                        setTimeout(
                                            function () {
                                                target
                                                    .find(".articlelist.events")
                                                    .addClass("ready")
                                                    .removeClass("loading");
                                            },
                                            500,
                                            target
                                        );

                                        $html.removeClass("ajax-wait");
                                    });
                            }

                            // --- 'Stjórnsýsla' menu, get seeking job ---
                            if (
                                e.target.classList.contains("blueish") &&
                                $(e.target).find(".megamenu .articlelist.job")
                                    .length < 1
                            ) {
                                $html.addClass("ajax-wait");
                                $.get("/stjornsysla", "justPicPos=pgmenu")
                                    .done(function (data) {
                                        if (
                                            $(e.target).find(
                                                ".megamenu .articlelist.job"
                                            ).length < 1
                                        ) {
                                            data = $.getResultBody(
                                                $.imgSuppress(data)
                                            ).find(".articlelist.job");
                                            data.addClass("loading");

                                            data.find("ins.image").css({
                                                "background-image":
                                                    "url(" +
                                                    data
                                                        .find("ins.image")
                                                        .attr("data-src") +
                                                    ")",
                                            });

                                            $(e.target)
                                                .find(".megamenu .boxbody")
                                                .append(data);
                                        }
                                    })
                                    .always(function () {
                                        var target = $(e.target);
                                        setTimeout(
                                            function () {
                                                target
                                                    .find(".articlelist.job")
                                                    .addClass("ready")
                                                    .removeClass("loading");
                                            },
                                            500,
                                            target
                                        );

                                        $html.removeClass("ajax-wait");
                                    });
                            }

                            //   mnav.find('.boxbody .level2').masonry({
                            //       itemSelector: '.level2 > li',
                            //       percentPosition: true,
                            //       transitionDuration: 0
                            //   });
                        })
                        .on("highlightoff", function (e) {
                            $(e.target)
                                .find(
                                    ".megamenu .articlelist.events .item.current"
                                )
                                .removeClass("current");
                            $(e.target)
                                .find(
                                    ".megamenu .articlelist.events .item.firstitem"
                                )
                                .addClass("current");
                            $(e.target)
                                .find(".megamenu .articlelist.events .next")
                                .show();
                            $("html").removeClass("curtain");
                        })
                        .on("click", function (e) {
                            e.stopPropagation();

                            if ($(e.target).parent().is(".focused")) {
                                media.isLarge &&
                                    mnav
                                        .find(".focused")
                                        .trigger("click", ["highlightOff"]);
                            }
                        });

                    $doc.on("click.megaClose", function (e) {
                        media.isLarge &&
                            mnav
                                .find(".focused")
                                .trigger("click", ["highlightOff"]);
                    }).on("keyup.megaClose", function (e) {
                        if (e.which === 27) {
                            media.isLarge &&
                                mnav
                                    .find(".focused")
                                    .trigger("click", ["highlightOff"]);
                        }
                    });
                } else if (media.leftLarge) {
                    mnav.find(".articlelist").remove();
                    mnav.find(".megamenu > .boxbody").zap();
                    mnav.find(".megamenu").zap();
                    mnav.off("highlighton");
                    mnav.off("click.megaClose");
                    $doc.off("keyup.megaClose");
                }
            }).trigger("formatchange.megaMenu");
        };

        /**************************************************************************************/
        /*** Open search  *******************************************************************/
        var openSearch = function () {
            var search = $(".qsearch");
            search.find(".boxhead").wrapInner('<a href="#"></a>');
            search.find(".boxhead > a").on("click", function (e) {
                e.preventDefault();
                media.isLarge && $(".mnav .focused > a").trigger("click");
                $html.toggleClass("search-open");
                search.find("#qstr").focus();
            });

            search.find(".boxbody").wrapInner("<div />");

            search
                .find(".fi_btn button, .fi_btn input")
                .on("click", function (e) {
                    if (search.find("#qstr").val().length < 1) {
                        if (media.isLarge) {
                            e.preventDefault();
                            search.find(".boxhead > a").click();
                        }
                    }
                });

            $doc.on("keyup", function (e) {
                if (e.which === 27 && $html.is(".search-open")) {
                    $html.removeClass("search-open");
                }
            });

            $body.click(function (e) {
                var $target = $(e.target);
                if (
                    !$target.parents().is(".qsearch") &&
                    !$target.is(".qsearch")
                ) {
                    $html.removeClass("search-open");
                }
            });
        };

        var initBreadcrumbs = function () {
            if ($html.is(".twocol")) {
                $(".breadcrumbs > div").wrapInner('<div class="links" />');
            }

            if ($(".pgmain .articlelist").length > 0) {
                $(".breadcrumbs").addClass("list");
            }
        };

        /**************************************************************************************/
        /*** Employee filter  *****************************************************************/
        var stafflist = !$html.is(".stafflist")
            ? noop
            : function () {
                  var stafftable = $(".stafflist table");
                  stafftable.filterTable({
                      multiFilter: true,
                      activeColClass: "",
                      hideRowClass: "hiderow",
                  });

                  var filterEmployee = $("#nameinput");
                  var eployeeInput = stafftable.find("td:nth-child(1) input");
                  var filterSvid = $("#svidselect");
                  var svidSelect = stafftable.find("td:nth-child(2) input");

                  // Starfsmannaleit
                  filterEmployee.on("change keyup", function (/*e*/) {
                      eployeeInput.val($(this).val());
                      eployeeInput.change();
                  });

                  // Starfsheiti
                  filterSvid.on("change keyup", function (/*e*/) {
                      if ($(this).val() === "all") {
                          svidSelect.val("").change();
                      } else {
                          var selectedSvidVal = $(this)
                              .find("option:selected")
                              .val();
                          svidSelect.val(selectedSvidVal);
                          svidSelect.change();
                      }
                  });

                  // change phone number into links
                  stafftable.find("td.tel").each(function () {
                      var tel = $(this).text();
                      if (tel.length > 0) {
                          $(this).wrapInner(
                              '<a href="tel:' +
                                  $(this).text().replace(/\s/g, "") +
                                  '" class="tel"></a>'
                          );
                      }
                  });
              };

        /**************************************************************************************/
        /*** Í beinni  ************************************************************************/
        var beinni = !$html.is(".beinni")
            ? noop
            : function () {
                  var articleid = $(".article").data("aid");
                  $(".articlelist .item[data-aid=" + articleid + "]").remove();
              };

        var buttonBackground = function () {
            if (media.isLarge) {
                var originalBGplaypen = "#012d98", // $(".next a").css("background-color"),
                    x,
                    y,
                    xy,
                    bgWebKit,
                    bgMoz,
                    lightColor = "#0750d8",
                    gradientSize = 150;

                // Basic Demo
                $(
                    ".next a, .button, .moreolder a, .popularlist a, .fundagerdir button, .contactform button"
                )
                    .mousemove(function (e) {
                        // x  = e.pageX - this.offsetLeft;
                        // y  = e.pageY - this.offsetTop;
                        x = e.pageX - e.target.offsetLeft;
                        y = e.pageY - e.target.offsetTop;

                        var x = e.pageX - $(this).offset().left;
                        var y = e.pageY - $(this).offset().top;

                        xy = x + " " + y;
                        // console.log('xy: ', xy);

                        bgWebKit =
                            "-webkit-gradient(radial, " +
                            xy +
                            ", 0, " +
                            xy +
                            ", " +
                            gradientSize +
                            ", from(" +
                            lightColor +
                            "), to(rgba(255,255,255,0.0))), " +
                            originalBGplaypen;
                        bgMoz =
                            "-moz-radial-gradient(" +
                            x +
                            "px " +
                            y +
                            "px 45deg, circle, " +
                            lightColor +
                            " 0%, " +
                            originalBGplaypen +
                            " " +
                            gradientSize +
                            "px)";

                        $(this)
                            .css({ background: bgWebKit })
                            .css({ background: bgMoz });
                    })
                    .mouseleave(function (e) {
                        if ($(e.target).parents(".popularlist").length > 0) {
                            $(e.target).css("background", "#F8F9FB"); //removeAttr('style');
                            return;
                        }

                        var me = $(this);
                        var i = 150;
                        var myGuy = setInterval(
                            function () {
                                if (i < 0) {
                                    clearInterval(myGuy);
                                } else {
                                    bgWebKit =
                                        "-webkit-gradient(radial, " +
                                        xy +
                                        ", 0, " +
                                        xy +
                                        ", " +
                                        i +
                                        ", from(" +
                                        lightColor +
                                        "), to(rgba(255,255,255,0.0))), " +
                                        originalBGplaypen;
                                    bgMoz =
                                        "-moz-radial-gradient(" +
                                        x +
                                        "px " +
                                        y +
                                        "px 45deg, circle, " +
                                        lightColor +
                                        " 0%, " +
                                        originalBGplaypen +
                                        " " +
                                        i +
                                        "px)";

                                    me.css({ background: bgWebKit }).css({
                                        background: bgMoz,
                                    });

                                    i = i - 50;
                                }
                            },
                            30,
                            me
                        );
                    });
            }
        };

        const iframeResize = function () {
            let htmlRoot = document.querySelector("html");

            if (htmlRoot.classList.contains("iframe")) {
                let iframeHeight = 1200;

                let classList = Array.from(htmlRoot.classList);
                let findIframeHeight = classList.find((string) =>
                    string.startsWith("iframe-")
                );

                if (findIframeHeight) {
                    let matchIframeHeight = findIframeHeight.match(/\d+$/);
                    iframeHeight = matchIframeHeight;
                }

                const pgMain = document.querySelector(".pgmain");
                const iframe = pgMain.querySelectorAll("iframe");
                iframe.forEach((item) => {
                    item.style.width = "100%";
                    item.style.height = `${iframeHeight}px`;
                    item.style.border = "none";
                });
            }
        };

        /**************************************************************************************/
        /*** Quick feedback - Var efnið hjálplegt *********************************************/
        var initQuickFeedback = function (root) {
            root.query(".didithelp").quickFeedback();
        };

        var insertPageStylesButtons = function () {
            $.makePageStyles({
                appendTo: ".pgextra2",
                fontsizeBtns: false,
                userstyles: true,
            });
        };

        // =========================================================================================================================
        //   Run Init Actions
        // =========================================================================================================================

        insertPageStylesButtons();

        $doc.on("domupdated.main", function (e, updatedFragment) {
            var root = $(updatedFragment || this);

            // Scripts sem hafa áhrif á article content eiga ekki að keyra þegar notendur eru loggedIn vegna ritilsins.
            !loggedIn && root.query("table").wrap('<div class="tablewrap" />');
            !loggedIn &&
                root.query("ol").attr("data-oltype", function () {
                    return this.type || "";
                }); // enable fancy styling on <ol> markers....
            !loggedIn && root.query(".netfang").mailtoEnabler(); //enable mailto links

            initQuickFeedback(root);

            !loggedIn && tagFileAndExternalLinks(root); // Þarf að keyrast soldið seint vegna ga tracking

            !loggedIn && isNormalStyles && prepArticleContent(root);

            initForms(root);
        }).trigger("domupdated.main");

        $.initMobileMenu({
            mediaGroup: "HeaderSmall",
            stickyHeader: false,
            resetScroll: true,
        });
        $.initStickyHeader({
            minimal: true,
            headerHeight: function () {
                return parseInt(
                    window
                        .getComputedStyle(document.documentElement)
                        .getPropertyValue("padding-top")
                );
            },
        }).start();
        collapseMobileMenu();
        handleTelephoneLinks(); // <- depends on formatChange

        isNormalStyles && initAlertBox();

        /* !loggedIn && */ initArticlelists();
        initHomepage();
        initBreadcrumbs();
        isNormalStyles && initMegaMenu();
        openSearch();
        !loggedIn && stafflist();
        !loggedIn && iframeResize();
        beinni();
        removeRedundantSpinners();

        buttonBackground();

        setTimeout(function () {
            $("html").addClass("js-done");
        }, 500);

        $("html").addClass("js-donenow");

        $("html").removeClass("beforejsinit"); //remove flicker trick

        $.fixSkiplinks && $.fixSkiplinks();

        // // Loading body class scripts
        // var theme_revision = window.Req.joinUrl.split('%7C').slice(1).pop();
        // var debugSrc = document.location.search.indexOf('jsdebug') > 0 ? '-source' : '';
        // Req.loadPageScripts({ folder:'', ext: debugSrc+'.js?'+theme_revision, rootElm: document.documentElement });
    }
);
